import {formatCurrency} from "../../../shared/utils";
import dayjs from "dayjs";
import {useTranslation} from "react-i18next";
import FundWallet from "./FundWallet";
import {useState} from "react";
import {useAppSelector} from "../../../hooks/redux";
import {useQuery} from "react-query";
import {getWallet} from "../../../shared/queries";
import {WalletData} from "../../../types";
import WalletOperations from "./WalletOperations";

export default function Wallet({ onAddMethod } : { onAddMethod: () => void }) {

    const { t } = useTranslation();
    const currentHotelObject = useAppSelector(state => state.hotels.currentHotelObject)

    const [showOperations, setShowOperations] = useState(false);
    const [showFundDialog, setShowFundDialog] = useState(false);

    const { data, isLoading, refetch } = useQuery<WalletData>([
        'accommodationWallet',
        currentHotelObject?.idAccomodation
    ], () => getWallet(currentHotelObject?.idAccomodation || 0));

    return (
        <>
            <div className={'card-bg h-64 rounded-md rounded-b-none p-4 shadow-xl'}>

                <FundWallet
                    isVisible={showFundDialog}
                    onAddMethod={() => {
                        setShowFundDialog(false)
                        onAddMethod()
                    }}
                    onCancel={() => setShowFundDialog(false)}
                    onSuccess={() => {
                        setShowFundDialog(false)
                        refetch()
                    }}
                />
                <WalletOperations isVisible={showOperations} onCancel={() => setShowOperations(false)} />

                <div className="h-full flex flex-col justify-between">
                    <div className="flex justify-between">
                        <div>
                            <img src="/assets/taptopay.svg" alt=""/>
                        </div>
                        <div>
                            <img className={'w-48'} src="/assets/walletlogo.svg" alt=""/>
                        </div>
                    </div>

                    <div className="flex flex-1 items-center justify-between">
                        <div>
                            <img src="/assets/chip.svg" alt="card chip"/>
                        </div>
                        <div>
                            {
                                data ?
                                    <>
                                        <div className="text-right text-4xl text-white">
                                            {formatCurrency(data.amount)}
                                        </div>
                                        <div className={'text-right mt-1 text-slate-100'}>
                                            {t('wallet.updatedAt')} {dayjs(data.lastUpdate).format('DD/MM/YYYY HH:mm')}
                                        </div>
                                    </>
                                    :
                                    <></>
                            }
                        </div>
                    </div>

                    <div className={'nova-mono-regular flex justify-between text-white'}>
                        <div>
                            {
                                data && `01829 91829 0000${data.idAccommodation}`
                            }
                        </div>

                        <div>
                        {currentHotelObject?.accomodationName}
                        </div>
                    </div>
                </div>
            </div>
            <div className={'bg-slate-800 rounded-md rounded-tr-none rounded-tl-none flex space-x-2 p-2'}>
                <div>
                    <button
                        onClick={() => setShowFundDialog(true)}
                        className={'rounded-md bg-orange-600 text-white font-medium px-2 py-1'}
                    >
                        {t('wallet.fundWallet')}
                    </button>
                </div>
                <div>
                    <button onClick={() => setShowOperations(true)} className={'rounded-md bg-white shadow text-gray-700 font-medium px-2 py-1'}>
                        {t('wallet.viewMovements')}
                    </button>
                </div>
            </div>
        </>
    )

}